import { mapState } from "vuex"

export default {
  data: () => ({
    fullDadataSuggest: []
  }),
  computed: {
    ...mapState(['form', 'DaDataToken', 'DaDataUrl'])
  },
  methods: {
    async dadataSuggest(query, config = {}) {
      if (config.refresh === undefined)
        config.refresh = true
      if (config.split === undefined)
        config.split = false
      if (!config.settings)
        config.settings = {
          query: query,
          count: 5,
          "locations": [{ "country": "Россия" }]
        }
      if (!config.filterFunction)
        config.filterFunction = el => el.data && el.data.city_kladr_id && (!el.data.house || el.data.house_kladr_id)
      
      let { split, settings, filterFunction } = config
      if (!split && config.refresh)
        this.fullDadataSuggest = []
      let url = this.DaDataUrl,
        token = this.DaDataToken,
        options = {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": "Token " + token
          },
          body: JSON.stringify(settings)
        }
      let sg = await (fetch(url, options)
        .then(response => response.json())
        .then(res => res.suggestions.filter(filterFunction))
        .catch(() => []))
      if (!split) {
        this.fullDadataSuggest = sg
        return sg.map(el => el.value)
      } else return ({
        full: sg,
        values: sg.map(el => el.value)
      })
    },
  },
}